import script from "./deliveryManageDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./deliveryManageDetail.vue?vue&type=script&setup=true&lang=js"

import "./deliveryManageDetail.vue?vue&type=style&index=0&id=1523a6e3&lang=less"

const __exports__ = script;

export default __exports__